import toShortPercentage from "./toShortPercentage";
export default v => (v < 0 ? "N/A" : toShortPercentage(v));
